import Vue from "vue";
import VueAnalytics from "vue-analytics";
import App from "./App.vue";
Vue.use(VueAnalytics, {
  id: "UA-118461456-1",
  autoTracking: {
    pageviewOnLoad: false,
    page: false
  }
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
